import HeaderReportMp from "../../../Components/ComponentsMarketplace/HeaderReportMp";
import ButtonsMap from '../../../Components/ComponentsMarketplace/ButtonsMap'
import { Tab, Tabs } from "react-bootstrap";
import CountUp from "react-countup";
import { Container, SizeContainer, ContainerCard, Paragraph } from "./style";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useUser } from "../../../providers/UserContext";
import Loading from "../../../Components/Loading";

const MarketplaceCashFlow = () => {

  const { user, rodada, jogo, marketPlace } = useUser()
  const [cashFlow, setCashFlow] = useState([])
  const [loading, setLoading] = useState(false)
  const [key, setKey] = useState('rodada-0');

  useEffect(() => {
    if (!marketPlace?.supermercado || !rodada?.rodada && !jogo?.jogo) {
      return
    }
    fetchCashFlow()

  }, [marketPlace, jogo, rodada])

  const fetchCashFlow = useCallback(async () => {
    try {
      setLoading(true)
      const { data: allRounds } = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/listarRodadas/${jogo?.jogo}`)
      const cashFlowPromises = allRounds
        .map(round =>
          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/lucroseperdas/obterSupermercadoRodada/${marketPlace?.supermercado}/${round?.rodada}`))

      const cashFlowData = await Promise.all(cashFlowPromises)
      const cashFLow = cashFlowData.map(item => item.data).filter(item => item.length > 0)

      const scheduleCashFlow = cashFLow.reduce((acumulator, currentItem, index) => {
        if (acumulator.length === 0) {
          const data = {
            saldoAnterior: marketPlace?.investimentoInicial,
            entrada: 0,
            saida: 0,
            saldo: 0
          }
          currentItem.forEach((item) => {
            if (item.tipo === "VENDA_SUPERMERCADO") {
              data.entrada += item.total
            } else {
              data.saida += item.total
            }

          })

          data.saldo = (marketPlace?.investimentoSaldo + data.entrada) - Math.abs(data.saida)

          acumulator.push(data)
          return acumulator
        }

        const data = {
          saldoAnterior: acumulator[index - 1].saldo,
          entrada: 0,
          saida: 0,
          saldo: 0
        }

        currentItem.forEach((item) => {
          if (item.tipo === "VENDA_SUPERMERCADO") {
            data.entrada += item.total
          } else {
            data.saida += item.total
          }
        })

        data.saldo = (data.saldoAnterior + data.entrada) - Math.abs(data.saida)

        acumulator.push(data)
        return acumulator
      }, [])

      setCashFlow(scheduleCashFlow)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [marketPlace, jogo, rodada])

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp
          title="Fluxo de Caixa"
          pathImg="./images/cash_flow.svg"
        />
        {loading ?
          <ContainerCard style={{ marginTop: 50 }}>
            <Loading />
          </ContainerCard>

          : (
            <Tabs
              style={{
                marginTop: 50
              }}
              id="controlled-tab"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3"
              fill
            >
              {cashFlow?.map((item, index) => {
                return (
                  <Tab key={index} eventKey={`rodada-${index}`} title={`Rodada ${index + 1}`}>
                    <ContainerCard>
                      {loading ? (
                        <Loading />
                      ) : (
                        <>
                          <Paragraph>Saldo Anterior :
                            <span style={{
                              color: '#000'
                            }}>
                              <CountUp
                                prefix="R$"
                                end={item?.saldoAnterior}
                                separator="."
                                decimal=","
                                decimals={2}
                                duration={0.5}
                              />
                            </span>
                          </Paragraph>
                          <Paragraph>Entrada:
                            <div >
                              <span style={{
                                color: '#14e891'
                              }}>
                                <CountUp
                                  prefix="+ R$"
                                  end={item?.entrada}
                                  separator="."
                                  decimal=","
                                  decimals={2}
                                  duration={0.5}
                                />
                              </span>
                            </div>
                          </Paragraph>
                          <Paragraph>Saída: <div ><span style={{
                            color: "red"
                          }} className='negative'>
                            <CountUp
                              prefix="- R$"
                              end={Math.abs(item?.saida)}
                              separator="."
                              decimal=","
                              decimals={2}
                              duration={0.5}
                            />
                          </span></div></Paragraph>
                          <Paragraph>Saldo: <span className='negative'>
                            <CountUp
                              prefix="R$"
                              end={item?.saldo}
                              separator="."
                              decimal=","
                              decimals={2}
                              duration={0.5}
                            /></span></Paragraph>
                          <Paragraph>Saldo Atual: <span style={{ color: '#000' }}>
                            <CountUp
                              prefix="R$"
                              end={item?.saldo}
                              separator="."
                              decimal=","
                              decimals={2}
                              duration={0.5}
                            /></span></Paragraph>
                        </>
                      )

                      }
                    </ContainerCard>
                  </Tab>
                )
              })

              }

            </Tabs>
          )
        }
        <ButtonsMap />
      </SizeContainer>
    </Container>
  );
};
export default MarketplaceCashFlow;
